import React, { Component } from 'react'
import { graphql } from 'gatsby'
import he from 'he'
import Seo from '../components/seo'
import RenderBlock from '../utils/render-block'

class PageTemplate extends Component {

  render() {
    let page = this.props.data.wpPage
    let isAgent = this.props.pageContext?.agent
    // Fallback for broken pages
    if (!page) return <div style={{ height: '100vh' }} />

    return (
      <>
        <Seo
          bodyClass={`${page.slug}${isAgent ? ' agent-site' : ''}`}
          path={page.uri}
          title={he.decode(page.seo.title)}
          description={page.seo.metaDesc}
          keywords={page.seo.metaKeywords}
          schema={page.seo.schema.raw}
        />
        {page?.acf?.contentBlocks?.map((el, i) => RenderBlock(el.fieldGroupName, el, i, 'page', this.props.theme))}
      </>
    )
  }
}

export const pageQuery = graphql`
  query ($id: String!) {
    wpPage(id: {eq: $id}) {
      title
      uri
      slug
      seo {
        ...WpSeo
      }
      acf {
        contentBlocks {
          ... on WpPage_Acf_ContentBlocks_HeroBanner {
            fieldGroupName
            backgroundImage {
              sourceUrl 
              altText
            }
            mobileImage {
              sourceUrl 
              altText
            }
            video
            mobileVideo
            title
          }
          ... on WpPage_Acf_ContentBlocks_Embed {
            fieldGroupName
            divId
            scriptSrc
          }
          ... on WpPage_Acf_ContentBlocks_PropertyOptions {
            fieldGroupName
            title
            items {
              image {
                sourceUrl 
                altText
              }
              title
              content
              text
              link
            }
            menu {
              text
              link
            }
            button {
              text
              link
            }
            theme
          }
          ... on WpPage_Acf_ContentBlocks_WhyUsShowcase {
            fieldGroupName
            image {
              sourceUrl 
              altText
            }
            items {
              title
              content
              link
              text
            }
            buttons {
              text
              link
            }
          }
          ... on WpPage_Acf_ContentBlocks_MediaOutlets {
            fieldGroupName
            title
            items {
              image {
                sourceUrl 
                altText
              }
              link
            }
          }
          ... on WpPage_Acf_ContentBlocks_LatestProperties {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_FeaturedNews {
            fieldGroupName
            title
            text
            link
          }
          ... on WpPage_Acf_ContentBlocks_SignOff {
            fieldGroupName
            image {
              sourceUrl 
              altText
            }
            title
            content
            buttons {
              text
              link
              subscribe
            }
            linkedToSubscribeForm
          }
          ... on WpPage_Acf_ContentBlocks_Suburbs {
            fieldGroupName
            title
            content
            menu {
              title
              suburbs {
                ... on WpSuburb {
                  title
                  slug
                  acf {
                    snippet
                    mobileImage {
                      sourceUrl 
                      altText
                    }
                    mainStat {
                      value
                      label
                    }
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_ThankYou {
            fieldGroupName
            backgroundImage {
              sourceUrl
            }
            backgroundMobileImage {
              sourceUrl
            }
            title
            content
            buttons {
              text
              link
            }
          }
          ... on WpPage_Acf_ContentBlocks_Contact {
            fieldGroupName
            title
            content
            form
            stickyButton
          }
          ... on WpPage_Acf_ContentBlocks_CommunityForm {
            fieldGroupName
            title
            content
          }
          ... on WpPage_Acf_ContentBlocks_LocationBlock {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_AchievementsBlock {
            fieldGroupName
            title
            awards {
              image {
                sourceUrl 
                altText
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_BusinessData {
            fieldGroupName
            title
            items {
              label
              value
            }
            disclaimer
          }
          ... on WpPage_Acf_ContentBlocks_WhyUsList {
            fieldGroupName
            title
            image {
              sourceUrl 
              altText
            }
            list {
              title
              content
            }
            button {
              url
              title
            }
          }
          ... on WpPage_Acf_ContentBlocks_AgentFullWidthButton {
            fieldGroupName
            button {
              title
              url
            }
          }
          ... on WpPage_Acf_ContentBlocks_FullImage {
            fieldGroupName
            image {
              sourceUrl
            }
            mobileImage {
              sourceUrl
            }
            desktopHeight
            mobileHeight
          }
          ... on WpPage_Acf_ContentBlocks_Video {
            fieldGroupName
            video
            image {
              sourceUrl
            }
            sideTitle
            title
            content
          }
          ... on WpPage_Acf_ContentBlocks_AboutTheArea{
            fieldGroupName
            title
            items {
              image {
                sourceUrl 
                altText
              }
              title
              content
              singleColumn
            }
            paddingBottom
          }
          ... on WpPage_Acf_ContentBlocks_TestimonialsBlock{
            fieldGroupName
            menu {
              text
              link
            }
            testimonials {
              quote
              name
              location
            }
            blogs
          }
          ... on WpPage_Acf_ContentBlocks_Timeline {
            fieldGroupName
            title
            blocks {
              title
              list {
                text
              }
              year
            }
          }
          ... on WpPage_Acf_ContentBlocks_Divisions {
            fieldGroupName
            title
            divisions {
              title
              content
            }
            extraPaddingTop
            extraPaddingBottom
          }
          ... on WpPage_Acf_ContentBlocks_NewStats {
            fieldGroupName
            title
            mainStat {
              value
              label
            }
            stats {
              value
              label
            }
            disclaimer
            image {
              sourceUrl
            }
          }
          ... on WpPage_Acf_ContentBlocks_Faqs {
            fieldGroupName
            title
            categories {
              title
              items {
                question
                answer
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Guides {
            fieldGroupName
            title
            categories {
              title
              items {
                image {
                  sourceUrl
                }
                title
                pdf {
                  sourceUrl
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_FeaturedTeamMembers {
            fieldGroupName
            items {
              ... on WpTeamMember {
                id
                slug
                title
                acf {
                  quote
                  aboutBio
                  aboutBioRightColumn
                  companyName
                  profileImage {
                    sourceUrl 
                    altText
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_CurrentListings {
            fieldGroupName
            type
          }
          ... on WpPage_Acf_ContentBlocks_CurrentAgentListings {
            fieldGroupName
            type
            agents {
              ... on WpTeamMember {
                teamDetails {
                  id
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_AgentPosts {
            fieldGroupName
            title
            agents {
              ... on WpTeamMember {
                id
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_AgentPodcast {
            fieldGroupName
            embed
          }
          ... on WpPage_Acf_ContentBlocks_TimedAuctions {
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_TeamMembers {
            fieldGroupName
            title
            items {
              ... on WpTeamMember {
                title
                slug
                teamDetails {
                  firstName
                  lastName
                  officeName
                  mobile
                  phone
                  email
                  jobTitle
                }
                acf {
                  companyName
                  thumbnailImage {
                    sourceUrl
                  }
                }
              }
            }
            agent
          }
          ... on WpPage_Acf_ContentBlocks_HeroBannerContact {
            fieldGroupName
            image {
              sourceUrl 
              altText
            }
            title
            content
            label
            text
            link
            address
            connect
          }
          ... on WpPage_Acf_ContentBlocks_HeroBannerAbout {
            fieldGroupName
            image {
              sourceUrl 
              altText
            }
            title
            content
            text
            video
            link
            extraPaddingBottom
            extraPaddingNoStats
          }
          ... on WpPage_Acf_ContentBlocks_HeroBannerTeam {
            fieldGroupName
            image {
              sourceUrl 
              altText
            }
            title
            content
            text
            link
          }
          ... on WpPage_Acf_ContentBlocks_OurPartnershipsBlock {
            fieldGroupName
            partnershipsTitle
            partnerships {
              title
              content
              text
              link
            }
            communityEffortsTitle
            communityEfforts {
              title
              content
              text
              link
            }
          }
          ... on WpPage_Acf_ContentBlocks_Support {
            fieldGroupName
            title
            categories {
              title
              name
            }
            items {
              title
              content
              text
              link
              category
            }
          }
          ... on WpPage_Acf_ContentBlocks_Opportunities {
            fieldGroupName
            title
            divisions {
              title
              name
            }
            jobs {
              title
              content
              text
              division
            }
          }
          ... on WpPage_Acf_ContentBlocks_News {
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_KolloscheTv {
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_BasicContent {
            fieldGroupName
            title
            content
            noPaddingTop
            noPaddingBottom
            researchInsights
            download {
              publicUrl
            }
            formTitle
            formThanks
            buttonText
            sendTo
          }
          ... on WpPage_Acf_ContentBlocks_HeroBannerAppraisal {
            fieldGroupName
            backgroundImage {
              sourceUrl
            }
            backgroundMobileImage {
              sourceUrl
            }
            image {
              sourceUrl 
              altText
            }
            title
            content
            text
            link
          }
          ... on WpPage_Acf_ContentBlocks_HeroBannerOffMarket {
            fieldGroupName
            image {
              sourceUrl 
              altText
            }
            title
            subtitle
            content
            menu {
              text
              link
            }
          }
          ... on WpPage_Acf_ContentBlocks_AgentPostsBlock {
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_ContactPopup {
            fieldGroupName
            title
            description
            formIntro
            image {
              sourceUrl 
              altText
            }
            fileDownload {
              sourceUrl
						}
          }
        }
      }
    }
  }
`

export default PageTemplate
